@let selectedFilter = _selectedFilter();
<div [attr.data-testid]="'filter-header'" class="filter-row-label">
  {{ 'GALAXY.FILTER.CHIP.WHERE' | translate }}
</div>
<div class="filter-editor-container">
  <div class="row field-row">
    @if (filteredOptions()) {
      <div>
        <glxy-form-field class="filter-operator-field" [bottomSpacing]="'none'">
          <input
            #searchInput
            [placeholder]="firstFilter?.fieldName || 'GALAXY.FILTER.CHIP.SELECT_FIELD_PLACEHOLDER' | translate"
            type="text"
            matInput
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            data-testid="field-text-input"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="fieldDisplayName.bind(this)"
            (optionSelected)="selectNewFilterFromDefinition($event.option.value)"
          >
            @for (option of filteredOptions(); track option) {
              <mat-option
                [value]="option.type === 'divider' ? '' : option.value"
                [disabled]="option.disabled"
                [class.option-divider]="option.type === 'divider'"
                [class.option-non-match]="option.type === 'non-match'"
                (mousedown)="option.type === 'divider' ? $event.preventDefault() : null"
                [attr.data-testid]="'filter-option-' + option.value.fieldId"
              >
                @if (option.type === 'divider') {
                  <span class="divider-text">
                    {{ 'GALAXY.FILTER.CHIP.OTHER_OPTIONS' | translate }}
                  </span>
                }
                @if (option.type !== 'divider') {
                  <span>{{ option.value.fieldName }}</span>
                }
              </mat-option>
            }
          </mat-autocomplete>
        </glxy-form-field>
      </div>
    }
    @let operatorOptionsList = operatorOptions();
    @let supportedOperatorsLength = filterDefinition()?.supportedOperators?.length;

    @if (supportedOperatorsLength > 1) {
      <div class="col field-col">
        <glxy-form-field class="filter-operator-field" [bottomSpacing]="'none'">
          <mat-select
            #operatorSelect
            class="filter-operator-selector"
            [placeholder]="'GALAXY.FILTER.CHIP.SELECT_OPERATOR_PLACEHOLDER' | translate"
            [formControl]="selectedOperatorControl"
            data-testid="filter-operator-selector"
          >
            @for (operatorOption of operatorOptionsList; track operatorOption) {
              <mat-option [value]="operatorOption.operator">{{ operatorOption.label | translate }}</mat-option>
            }
          </mat-select>
        </glxy-form-field>
      </div>
    } @else {
      @if (operatorOptionsList?.length === 1) {
        <div class="operator-label">
          {{ operatorOptionsList[0].label | translate }}
        </div>
      } @else {
        <div class="operator-label">
          {{ 'GALAXY.FILTER.CHIP.OPERATOR.IS' | translate }}
        </div>
      }
    }
    @if (filterDefinition(); as filterDefinition) {
      @switch (inputType()) {
        @case (FilterInputType.FILTER_INPUT_TYPE_SINGLE_SELECT_STRING) {
          <glxy-string-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [fieldId]="filterDefinition.fieldId"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_MULTI_SELECT_STRING) {
          <glxy-tags-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [tagsFieldId]="filterDefinition.fieldId ?? ''"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_SINGLE_SELECT_TAG) {
          <glxy-tags-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            (valueChanges)="filterValuesChanged($event)"
            [tagsFieldId]="filterDefinition.fieldId ?? ''"
            [disabled]="filterDefinition.lockedValue"
            [maxTags]="1"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_MULTI_SELECT_TAG) {
          <glxy-tags-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            (valueChanges)="filterValuesChanged($event)"
            [tagsFieldId]="filterDefinition.fieldId ?? ''"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_SINGLE_SELECT_RADIO) {
          <glxy-radio-filter-input
            class="row field-col"
            [fieldId]="filterDefinition.fieldId ?? ''"
            [initialValue]="selectedFilter?.values || []"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_MULTI_SELECT_CHECKBOX) {
          <glxy-checkbox-filter-input
            class="row field-col"
            [fieldId]="filterDefinition.fieldId ?? ''"
            [initialValue]="selectedFilter?.values || []"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_NO_INPUT) {
          <glxy-no-input-filter-input
            class="col field-col"
            [initialValue]="[]"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_DATE_SELECT) {
          <glxy-date-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [operator]="selectedOperatorControl.value"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_FLOAT) {
          <glxy-float-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [operator]="selectedOperatorControl.value"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_INTEGER) {
          <glxy-integer-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [operator]="selectedOperatorControl.value"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_BOOLEAN) {
          <glxy-boolean-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [disabled]="filterDefinition.lockedValue"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_CUSTOM_INPUT) {
          <glxy-custom-filter-input
            class="col field-col"
            [initialValue]="selectedFilter?.values || []"
            [filterOverride]="filterOverride()"
            [operator]="selectedOperator()"
            (valueChanges)="filterValuesChanged($event)"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_PHONE) {
          <glxy-phone-filter-input
            class="row field-row"
            [initialValue]="selectedFilter?.values || []"
            [fieldId]="filterDefinition.fieldId"
            (valueChanges)="filterValuesChanged($event)"
            [disabled]="filterDefinition.lockedValue"
          />
        }
        @case (FilterInputType.FILTER_INPUT_TYPE_NO_OPERATOR_SELECTED) {
          <glxy-none-selected-input-filter-input class="col field-col" />
        }
      }
    }
    @if (!filterDefinition()?.supportedOperators?.length || filterDefinition()?.supportedOperators?.length <= 1) {
      <ng-container>
        <ng-container *ngTemplateOutlet="applyButton" />
      </ng-container>
    }
  </div>
  @if (filterDefinition()?.supportedOperators?.length > 1) {
    <ng-container>
      <ng-container *ngTemplateOutlet="applyButton" />
    </ng-container>
  }
</div>

<ng-template #applyButton>
  <button mat-flat-button color="primary" class="row-button" (click)="applyFilter()" data-testid="filter-apply-button">
    {{ 'GALAXY.FILTER.CHIP.ACTIONS.APPLY' | translate }}
  </button>
</ng-template>
